module.exports = __webpack_public_path__ + "static/img/i48.f7ea9c45.png";